import { ReactSVG } from 'react-svg';
import { FC, useState } from 'react';

import DangerButton from 'components/form/buttons/danger';
import OutlineButton from 'components/form/buttons/outLineButton';
import ModalApp from 'components/modalApp';
import Gap from 'components/gap';

import * as S from './styles';
import PrimaryButton from 'components/form/buttons/primaryButton';

interface Question {
  show: boolean;
  handleClose: () => void;
  title?: string;
  text?: string;
  handleSuccess?: (note?: string) => void;
  successButtonText?: string;
  model: 'delete' | 'success';
  icon?: string;
  notePlaceholder?: string;
  note?: boolean;
}

/* Inline, so the glyph follows the soft ground's ink through `currentColor`. */
const TrashIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 6h18M8 6V4h8v2M6 6l1 14h10l1-14" />
  </svg>
);

const CheckIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 6L9 17l-5-5" />
  </svg>
);

const QuestionModal: FC<Question> = ({
  show,
  handleClose,
  title,
  text,
  handleSuccess,
  successButtonText,
  model,
  icon,
  notePlaceholder,
  note
}) => {
  const [noteText, setNoteText] = useState('');

  return (
    <S.Content>
      <ModalApp show={show} handleClose={handleClose} fixed={true} style={{ maxWidth: 400 }} center={true}>
        <S.ModalContent>
          {icon ? (
            <ReactSVG src={icon} />
          ) : (
            <S.Icon className={model}>{model === 'delete' ? <TrashIcon /> : <CheckIcon />}</S.Icon>
          )}
          <Gap size="var(--s4)" />
          <S.Title>{title}</S.Title>
          {text ? (
            <>
              <Gap size="var(--s1)" />
              <S.Text>{text}</S.Text>
            </>
          ) : (
            <></>
          )}
          {note && <S.Textarea placeholder={notePlaceholder} onChange={(e) => setNoteText(e.target.value)} />}
          <S.Buttons>
            {model === 'delete' ? (
              <>
                <OutlineButton
                  onClick={() => {
                    handleClose();
                    setNoteText('');
                  }}
                  style={{ flex: 1 }}
                >
                  Cancel
                </OutlineButton>

                <DangerButton
                  disabled={note && !noteText}
                  onClick={() => handleSuccess && handleSuccess(noteText)}
                  style={{ flex: 1 }}
                >
                  {successButtonText ? successButtonText : 'Remove'}
                </DangerButton>
              </>
            ) : model === 'success' ? (
              <>
                <OutlineButton
                  onClick={() => {
                    handleClose();
                  }}
                  style={{ flex: 1 }}
                >
                  Cancel
                </OutlineButton>
                <PrimaryButton onClick={handleSuccess} style={{ flex: 1 }}>
                  {successButtonText ? successButtonText : 'Remove'}
                </PrimaryButton>
              </>
            ) : (
              <></>
            )}
          </S.Buttons>
        </S.ModalContent>
      </ModalApp>
    </S.Content>
  );
};

export default QuestionModal;
